export default {
    vendorProducts: [],
    vendorProduct: {},
    totalItems: null,
    totalPage: null
};